import React from 'react';
import { useNavigate } from 'react-router-dom';

type ActivityDetail = {
  type: string;
  time: string;
  emailId?: number; // Add email ID for routing
};

type ActivityItem = {
  person: string;
  action: string;
  time: string;
  details?: ActivityDetail[];
  opens?: number;
  emailId?: number; // Add email ID for main activity routing
};

const getInitials = (name: string) => {
    const parts = name.split(' ');
    if (parts.length > 1 && parts[1]) {
        return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    }
    return name[0].toUpperCase();
}

const ActivityFeed: React.FC = () => {
  const navigate = useNavigate();
  
  const activities: { [key: string]: ActivityItem[] } = {
    Today: [
      {
        person: 'Elise',
        action: 'opened email Follow up',
        time: '12:29 PM',
        emailId: 4, // Reference to Elise's email in Messages
        details: [
          { type: 'Opened email Follow up', time: 'Today at 12:29 PM', emailId: 4 },
          { type: 'Was sent email Follow up', time: 'Today at 12:28 PM', emailId: 4 },
        ],
      },
    ],
    'This month': [
      {
        person: 'Sofia Sulikowski',
        action: 'opened email Re: Marketing Job Advice Part 2',
        time: 'December 3',
        opens: 7,
        emailId: 5, // Reference to Sofia's email in Messages
      },
    ],
    Older: [
      {
        person: 'Shreyas',
        action: 'opened email Re: Name correction',
        time: 'November 25',
        opens: 2,
        emailId: 6, // We'll need to add this email to Messages
      },
    ],
  };

  const handleActivityClick = (emailId?: number) => {
    if (emailId) {
      navigate(`/messages?emailId=${emailId}`);
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm h-full">
      <div className="mb-6">
        <h2 className="text-xl font-semibold text-gray-800 mb-2">Contact Activity Feed</h2>
        <p className="text-sm text-gray-500">Recent contact interactions and activities</p>
      </div>
      
      <div className="space-y-8">
        {Object.entries(activities).map(([period, items]) => (
          <div key={period}>
            <h3 className="text-sm font-semibold text-gray-600 mb-4 uppercase tracking-wide">{period}</h3>
            <div className="space-y-4">
              {items.map((item, index) => (
                <div key={index} className="relative">
                  <div className="flex items-start space-x-3">
                    <div className="flex-shrink-0">
                      <div className="h-8 w-8 rounded-full bg-gradient-to-br from-orange-400 to-orange-600 flex items-center justify-center text-xs font-bold text-white shadow-sm">
                        {getInitials(item.person)}
                      </div>
                    </div>
                    <div className="flex-1 min-w-0">
                      <div 
                        className="bg-gray-50 rounded-lg p-4 border border-gray-100 hover:bg-gray-100 transition-colors duration-150 cursor-pointer"
                        onClick={() => handleActivityClick(item.emailId)}
                      >
                        <p className="text-sm text-gray-800 leading-relaxed">
                          <span className="font-semibold text-gray-900">{item.person}</span> {item.action}
                        </p>
                        <p className="text-xs text-gray-500 mt-1">{item.time}</p>
                        
                        {item.details && (
                          <div className="mt-3 space-y-2">
                            <div className="flex items-center justify-between mb-2">
                              <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                1 open
                              </span>
                            </div>
                            {item.details.map((detail: ActivityDetail, i: number) => (
                              <div 
                                key={i} 
                                className="p-3 bg-white rounded-md border border-gray-200 hover:border-blue-300 hover:bg-blue-50 transition-colors duration-150 cursor-pointer"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleActivityClick(detail.emailId);
                                }}
                              >
                                <div className="flex justify-between items-center">
                                  <span className="text-xs text-gray-800 font-medium">{detail.type}</span>
                                  <span className="text-xs text-gray-400">{detail.time}</span>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                        
                        {item.opens && (
                          <div className="mt-3">
                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                              {item.opens} opens
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityFeed;
